module.exports = __webpack_public_path__ + "media/images/Vectornavy-4a318189.png";